import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { flipCardVariants } from './animations';
import type { FeatureCardProps } from './types';
import CardFront from './card/CardFront';
import CardBack from './card/CardBack';
import './styles/cardHover.css';

export default function FeatureCard(props: FeatureCardProps) {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div 
      className="relative w-full h-[280px] perspective-1000 feature-card"
      onClick={() => setIsFlipped(!isFlipped)}
      role="button"
      tabIndex={0}
      aria-label={`Click to ${isFlipped ? 'see benefit' : 'discover feature'}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsFlipped(!isFlipped);
        }
      }}
    >
      <motion.div
        initial={false}
        animate={isFlipped ? 'back' : 'front'}
        variants={flipCardVariants}
        className="w-full h-full relative preserve-3d cursor-pointer"
      >
        <CardFront {...props} isFlipped={isFlipped} />
        <CardBack {...props} isFlipped={isFlipped} />
      </motion.div>
    </div>
  );
}